import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { SecurityService } from '../../../services/security/security.service';
import { HttpErrorResponse } from '@angular/common/http';
import { MessagesTitles, MessagesStatus } from '../../../models/messages';
import Swal, { SweetAlertResult } from "sweetalert2";
import { Router } from '@angular/router';

@Component({
  selector: 'app-nuevo-rol',
  templateUrl: './nuevo-rol.component.html',
  styleUrls: ['./nuevo-rol.component.scss'],
  providers: [MessagesTitles, MessagesStatus]
})
export class NuevoRolComponent implements OnInit {
  @Output() cerrarPopUpRol: EventEmitter<boolean>;
  @Output() refresh = new EventEmitter<any>();
  editar: boolean;
  loading: boolean = false;
  isLoading = true;
  save: boolean = false;
  dataRol: any;
  repSistemas: any = [];
  user: any;
  ipAddress: any;
  formularioRol: FormGroup;
  idEmpresa: string;
  Titulo: string;
  disableSelect: boolean = false;

  constructor(private securityService: SecurityService,
    private router: Router,
    private msgTitulos: MessagesTitles,
    private msgStatus: MessagesStatus) {

    try {
      this.dataRol = this.securityService.dataRol;
    } catch (error) {
      this.router.navigate(['/rol/listado']);
    }

    this.Titulo = "Nuevo Rol";
    this.cerrarPopUpRol = new EventEmitter();
    this.editar = false;

    this.user = JSON.parse(sessionStorage.getItem('UserActive'));
    this.ipAddress = JSON.parse(sessionStorage.getItem('PUBLIC-IP'));

    this.formularioRol = new FormGroup({
      id_roles: new FormControl(this.dataRol.id_roles),
      id_sistemas: new FormControl("", [Validators.required]),
      Nombre: new FormControl("", [Validators.required]),
      id_Empresa: new FormControl(this.user.id_empresa),
      NombreProyecto: new FormControl('DigitalFactoring', []),
      Usuario: new FormControl(this.user.Usuario, []),
      Host: new FormControl('INTRANET', []),
      IP: new FormControl(this.ipAddress.ip, []),
      Canal: new FormControl('W', [])
    },
    )
  }

  ngOnInit() {

    this.ObtenerListaSistemas();

    if (this.securityService.dataRol != "") {
      this.disableSelect = true;
      this.Titulo = "Editar Rol";
      this.editar = true;
      this.formularioRol.controls['Nombre'].setValue(this.dataRol.Nombre);
      this.formularioRol.controls['id_sistemas'].setValue(this.dataRol.id_sistemas);
    }
  }

  guardarRol() {

    if (this.formularioRol.invalid) {

      Swal.fire({
        title: "CAMPOS VALIDADOS",
        text: "Verficiar los campos resaltados de color rojo",
        type: "warning",
        allowOutsideClick: true,
        heightAuto: false
      })
      return;
    }
    if (this.editar) {
      Swal.fire({
        title: 'Espere',
        text: 'Actualizando Información',
        type: 'info',
        allowOutsideClick: false,
        heightAuto: false
      });
      Swal.showLoading();

      this.securityService.ActualizarRol(this.formularioRol.getRawValue())
        .subscribe(resp => {
          Swal.fire({
            title: "Felicidades",
            text: "Rol actualizado correctamente",
            type: "success",
            allowOutsideClick: false,
            heightAuto: false
          }).then(res => {
            this.emitFunction(res);
          });
        }, (err: HttpErrorResponse) => {

          if (err.error instanceof ErrorEvent) {
            console.error(err);
          } else {
            this.msgStatus.getMessage(err.status);
          }
          Swal.fire({
            title: this.msgTitulos.Error,
            text: "ROL NO ACTUALIZADO. " + this.msgStatus.message,
            type: "error",
            allowOutsideClick: true,
            heightAuto: false
          })
        });
    } else {
      Swal.fire({
        title: 'Espere',
        text: 'Guardado Información',
        type: 'info',
        allowOutsideClick: false,
        heightAuto: false
      });
      Swal.showLoading();

      this.securityService.registrarRoles(this.formularioRol.getRawValue())
        .subscribe(resp => {

          Swal.fire({
            title: "Felicidades",
            text: "Rol registrado correctamente",
            type: "success",
            allowOutsideClick: false,
            heightAuto: false
          }).then(res => {
            this.emitFunction(res);
          });
        }, (err: HttpErrorResponse) => {

          if (err.error instanceof ErrorEvent) {
            console.error(err);
          } else {
            this.msgStatus.getMessage(err.status);
          }
          Swal.fire({
            title: this.msgTitulos.Error,
            text: "ROL NO GUARDADO. " + this.msgStatus.message,
            type: "error",
            allowOutsideClick: true,
            heightAuto: false
          })
        });
    }
  }

  emitFunction(res: SweetAlertResult) {
    if (res.value) {
      this.cerrarPopUpRol.emit();
      this.refresh.emit();
      this.router.navigate(['/rol/listado']);
    }
  }


  ObtenerListaSistemas() {
    this.loading = true;
    this.securityService.ObtenerListaSistemas()
      .subscribe(resp => {
        this.repSistemas = resp
        this.loading = false;
      }, (err: HttpErrorResponse) => {
        if (err.error instanceof ErrorEvent) {
          console.error(err);
        } else {
          this.msgStatus.getMessage(err.status);
        }
        Swal.fire({
          title: this.msgTitulos.Error,
          text: "LISTA SISTEMAS NO OBTENIDA. " + this.msgStatus.message,
          type: "error",
          allowOutsideClick: false,
          heightAuto: false
        });
      })
  }

  CerrarPopUp() {
    this.cerrarPopUpRol.emit();
  }

}
